import {combineReducers} from 'redux';
import {createReducer} from 'redux-orm';

import gtfs from 'ducks/gtfs';
import map from 'ducks/map';

import orm from 'models/models';

const ormReducer = createReducer(orm);

const reducer = combineReducers({
    gtfs,
    map,
    orm: ormReducer,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/reducer.js